import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';

const PRIME_NG_MODULES = [
  ButtonModule,
  ProgressBarModule,
  DropdownModule,
  InputTextModule,
  DialogModule,
  TableModule,
  TooltipModule,
  CheckboxModule,
  RadioButtonModule,
  CalendarModule,
];

@NgModule({
  imports: [CommonModule, ...PRIME_NG_MODULES],
  exports: PRIME_NG_MODULES,
})
export class PrimeNgModule {}
